import {useStyles} from '@wix/tpa-settings/react'
import {ExperimentNames, LIST_LAYOUT_TYPE} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import stylesParams from '../../../../stylesParams'
import {useWidgetState} from '../../../hooks/state-provider'
import {useEventsList} from '../../../hooks/use-events-list'
import {getCompId} from '../../../selectors/component'
import {focusFirstNewEvent} from '../../../utils/a11y'
import {LoadMoreButton} from '../../load-more-button'
import {MainListTitle} from '../../main-list-title'
import {DesktopItem} from '../item'
import {ListProps} from './interfaces'
import s from './list.scss'

export const List = ({narrow, mobile}: ListProps) => {
  const {events, hasMore, moreLoading, pageLimit} = useEventsList()
  const {experiments} = useExperiments()
  const {get} = useStyles()

  const compId = useWidgetState(getCompId)
  const eventsCount = events.length
  const listCards = get(stylesParams.listLayoutType) === LIST_LAYOUT_TYPE.CARDS

  const style: React.CSSProperties = {
    overflowY: narrow && !mobile ? 'scroll' : 'hidden',
    height: narrow && !mobile ? '100%' : 'auto',
  }
  const className = classNames(s.container, s.scrollBarColor, s.padding, {
    [s.listContainer]: experiments.enabled(ExperimentNames.MobileSettingsPanelRevamp) || !listCards,
  })

  useEffect(() => {
    focusFirstNewEvent({eventsCount, pageLimit, hasMore, compId})
  }, [eventsCount])

  return (
    <div className={className} style={style} data-hook="ev-list-layout">
      <MainListTitle />
      <ul>
        {events.map(event => (
          <DesktopItem key={event.id} event={event} />
        ))}
      </ul>
      <LoadMoreButton hasMore={hasMore} moreLoading={moreLoading} />
    </div>
  )
}
